export class TestIds {
  private static readonly uuid = '0f01cbba-0288-4a09-989f-209de56beaae';
  public static readonly FILTER_INPUT = `${TestIds.uuid}-filter-input`;
  public static readonly SIMPLE_INPUT = `${TestIds.uuid}-simple-input`;
  public static readonly SELECT_ALL_BUTTON = `${TestIds.uuid}-select-all-button`;
  public static readonly DESELECT_ALL_BUTTON = `${TestIds.uuid}-deselect-all-button`;
  public static readonly DROPDOWN_ITEM = `${TestIds.uuid}-dropdown-item`;
  public static readonly SELECTED_DROPDOWN_ITEM = `${TestIds.uuid}-selected-dropdown-item`;
}
